<template>
  <div class="order-detail">
    <!-- 标题栏 -->
    <el-card class="mb-20">
      <div class="header">
        <span class="title">订单详情</span>
        <div>
          <span class="order-no">订单号：{{ detailData.orderSn }}</span>
          <el-tag type="success" size="mini" @click="copyOrderNo">复制</el-tag>
        </div>
      </div>
    </el-card>

    <!-- 商品信息 -->
    <el-card class="mb-20">
      <div class="info-title">商品信息</div>
      <div class="goods-list">
        <div class="goods-item" v-for="item in detailData.orderProductList" :key="item.id">
          <div class="goods-img-box">
            <img :src="item.newImg" class="goods-img" />
          </div>
          <div class="goods-info">
            <div class="goods-title">{{ item.goodsName }}</div>
            <div class="goods-spec">规格：{{ item.specification }}</div>
            <div class="goods-meta">
              <span class="goods-price">￥{{ item.price.toFixed(2) }}</span>
              <span class="goods-count">数量：{{ item.buyNum }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 订单信息 -->
    <div class="order-section">
      <div class="info-title">
        <i class="el-icon-document" style="color: #13ce66; margin-right: 6px;"></i>
        订单信息
      </div>
      <div class="transaction-info-horizontal">
        <div class="transaction-info-left">
          <div class="transaction-info-item">
            <div class="transaction-info-label">订单编号</div>
            <div class="transaction-info-value">
              <span class="order-no-copy">{{ detailData.orderSn }}</span>
              <el-tag type="success" size="mini" @click="copyOrderNo">复制</el-tag>
            </div>
          </div>
          <div class="transaction-info-item">
            <div class="transaction-info-label">支付状态</div>
            <div class="transaction-info-value">
              <span class="pay-status paid">{{ detailData.orderStatus == 0 ? '已取消' : detailData.orderStatus == 1 ? '待付款'
                : detailData.orderStatus == 2 ? '待发货' : detailData.orderStatus == 3 ? '已发货' : '已收货' }}</span>
            </div>
          </div>
        </div>
        <div class="transaction-info-right">
          <div class="transaction-info-item">
            <div class="transaction-info-label">交易时间</div>
            <div class="transaction-info-value">
              <span class="bold">{{ detailData.payTime || '--' }}</span>
            </div>
          </div>
          <div class="transaction-info-item">
            <div class="transaction-info-label">支付方式</div>
            <div class="transaction-info-value">
              <span class="bold">微信支付</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 收货信息 -->
    <div class="order-section">
      <div class="info-title">
        <i class="el-icon-location" style="color: #13ce66; margin-right: 6px;"></i>
        收货信息
      </div>
      <div class="address-info-horizontal">
        <div class="address-info-left">
          <div class="address-row">
            <span class="address-label">收货人</span>
            <span class="address-value">{{ detailData.address.userName }}</span>
          </div>
          <div class="address-row">
            <span class="address-label">收货地址</span>
            <span class="address-value">{{ detailData.address.province }}{{ detailData.address.city }}{{
              detailData.address.area }} {{ detailData.address.address }}</span>
          </div>
          <div class="address-row">
            <span class="address-label">配送方式</span>
            <span class="address-value">快递配送</span>
          </div>
        </div>
        <div class="address-info-right">
          <div class="address-row">
            <span class="address-label">联系电话</span>
            <span class="address-value">{{ detailData.address.phone }}</span>
          </div>
          <!-- <div class="address-row">
            <span class="address-label">配送要求</span>
            <span class="address-value">工作日配送</span>
          </div> -->
        </div>
      </div>
    </div>
    <!-- 价格信息 -->
    <div class="order-section">

      <div class="info-title">
        <i class="el-icon-money" style="color: #13ce66; margin-right: 6px;"></i>
        价格信息
      </div>
      <div class="price-info-list">
        <div class="price-info-row">
          <span class="price-info-label">商品总价</span>
          <span class="price-info-value">￥{{ TotaglPrice.toFixed(2) }}</span>
        </div>
        <div class="price-info-row">
          <span class="price-info-label">运费</span>
          <span class="price-info-value">￥{{ totalMailPrice.toFixed(2) }}</span>
        </div>
      </div>
    </div>
    <!-- 订单总金额 -->
    <div class="order-total-amount">
      订单总金额：<span class="order-total-amount-value">￥{{ orderTotalAmount.toFixed(2) }}</span>
    </div>
    <!-- 物流信息 -->

    <div class="logistics-section" v-if="logistics && logistics.length">
      <div class="info-title">
        <i class="el-icon-truck" style="color: #13ce66; margin-right: 6px;"></i>
        物流信息
      </div>
      <el-timeline>
        <el-timeline-item v-for="(log, index) in logistics" :key="index" :timestamp="log.timeDesc"
          :color="index === 0 ? '#13ce66' : ''" placement="top">
          <div class="logistics-desc">
            <div class="logistics-status">
              <span class="logistics-city">{{ log.areaName }}</span>
              <span class="logistics-status-text">{{ getStatusText(log.logisticsStatus) }}</span>
            </div>
            <div class="logistics-detail">{{ log.desc }}</div>
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>


  </div>
</template>

<script>
import {
  orderDetail,
  getLogisticsInfo
} from '@/api/sjzx'
export default {
  data() {
    return {
      detailData: [],
      baseUrl: window.globalUrl.HOME_API,
      logistics: [],
      // TotaglPrice:0
    }
  },
  mounted() {
    this.initData()
  },
  computed: {
    //商品总价
    TotaglPrice() {
      if (!this.detailData.orderProductList) return 0;
      return this.detailData.orderProductList.reduce((sum, item) => {
        return sum + (item.price * item.buyNum);
      }, 0);
    },
    //商品运费
    totalMailPrice() {
      if (!this.detailData.orderProductList) return 0;
      return this.detailData.orderProductList.reduce((sum, item) => {
        return sum + (item.mailPrice || 0);
      }, 0);
    },
    orderTotalAmount() {
      return this.TotaglPrice + this.totalMailPrice;
    }
  },
  methods: {
    changeList(arr) {
      //改变订单图片结构

      arr.orderProductList.forEach(its => {
        try {
          if (its.goodsImg) {
            its.newImg = this.baseUrl + 'admin/file/get?ossFilePath=' + JSON.parse(its.goodsImg)[0].url;
          }

        } catch (error) {
          console.error('解析JSON字符串时出错:', error);
        }
      });

      return arr
    },
    async initData() {
      //初始数据
      let res = await orderDetail({ orderItemId: this.$route.query.orderItemId })
      this.detailData = this.changeList(res.data)
      this.logistics = res.data.logisticsData.logisticsTraceDetailList
      //物流信息
      // let res2 = await getLogisticsInfo({ orderItemId: this.$route.query.orderItemId })
      // this.logistics = res2.data
    },
    copyOrderNo() {
      const orderNo = this.detailData.orderNo || '20230615123456';
      if (navigator.clipboard) {
        navigator.clipboard.writeText(orderNo).then(() => {
          this.$message.success('订单号已复制');
        });
      } else {
        // 兼容性处理
        const input = document.createElement('input');
        input.value = orderNo;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        this.$message.success('订单号已复制');
      }
    },
    getStatusText(status) {
      const map = {
        'ACCEPT': '已揽收',
        'TRANSPORT': '运输中',
        'DELIVERED': '已签收',
        'AGENT_SIGN': '代收签收',
        'DELIVERING': '派送中',
        'SIGN': '已签收'
        // 可根据实际数据补充
      }
      return map[status] || status
    }
  }
}
</script>

<style scoped>
.order-detail {
  background: #f7f8fa;
  padding: 20px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-radius: 8px 8px 0 0;
  padding: 24px;
  box-shadow: none;
  border: none;
}

.title {
  font-size: 20px;
  font-weight: bold;
}

.order-no {
  color: #888;
  margin-left: 20px;
}

.mb-20 {
  margin-bottom: 20px;
}

.goods-list {
  display: flex;
  flex-direction: column;
}

.goods-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.goods-item:last-child {
  border-bottom: none;
}

.goods-img-box {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  flex-shrink: 0;
}

.goods-img {
  width: 100%;
  height: 100%;
  /* object-fit: contain; */
}

.goods-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 6px;
  position: relative;
  height: 100px;
  /* 保证有足够空间 */
}

.goods-title,
.goods-spec {
  /* 保持默认即可 */
}

.goods-spec {
  color: #888;
  font-size: 13px;
}

.goods-meta {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 18px;
}

.goods-price,
.goods-count {
  font-size: 15px;
  text-align: right;
}

.goods-price {
  color: #13ce66;
}

.goods-count {
  color: #888;
}

.info-title {
  font-weight: bold;
  margin-bottom: 20px;
  margin-top: 8px;
}

.total {
  margin-top: 10px;
  font-size: 16px;
}

.total-price {
  color: #13ce66;
  font-weight: bold;
}

.order-no-copy {
  margin-left: 8px;
  color: #333;
  font-weight: 500;
}

.pay-status.paid {
  color: #13ce66;
  margin-left: 8px;
}

.bold {
  font-weight: bold;
  margin-left: 8px;
}

.transaction-info-horizontal {
  display: flex;
  flex-direction: row;
  gap: 40px;
}

.transaction-info-left,
.transaction-info-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.transaction-info-item {
  display: flex;
  align-items: flex-start;
}

.transaction-info-label {
  min-width: 80px;
  color: #666;
  font-size: 15px;
  text-align: left;
  flex-shrink: 0;
}

.transaction-info-value {
  flex: 1;
  text-align: left;
  font-size: 15px;
  color: #333;
}

.address-info-horizontal {
  display: flex;
  flex-direction: row;
  gap: 40px;
}

.address-info-left,
.address-info-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.address-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 4px;
}

.address-label {
  color: #888;
  min-width: 70px;
  font-size: 15px;
}

.address-value {
  color: #222;
  font-weight: 500;
  word-break: break-all;
  font-size: 15px;
}

.price-info-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.price-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.price-info-label {
  color: #888;
  font-size: 15px;
}

.price-info-value {
  color: #222;
  font-size: 15px;
  font-weight: bold;
}

.order-detail-module {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  padding: 0 0 0 0;
  margin-bottom: 20px;
}

.order-section {
  padding: 24px 24px 0 24px;
  border-bottom: 1px solid #f0f0f0;
}

.order-section-last {
  border-bottom: none;
  padding-bottom: 24px;
}

.el-card.mb-20:first-child {
  background: #fff !important;
  box-shadow: none !important;
  border: none !important;
  margin-bottom: 20px;
}

.order-total-amount {
  font-size: 18px;
  font-weight: bold;
  color: #222;
  margin-bottom: 8px;
  margin: 20px 0px;
  margin-left: 20px;
}

.order-total-amount-value {
  color: #13ce66;
  font-size: 22px;
  font-weight: bold;
  margin-left: 8px;
}

.logistics-section {
  padding: 24px;
  background: #fff;
  border-radius: 8px;
  margin-bottom: 20px;
}

.logistics-desc {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.logistics-status {
  display: flex;
  gap: 12px;
  font-weight: bold;
  color: #222;
}

.logistics-city {
  color: #13ce66;
}

.logistics-status-text {
  color: #888;
  font-size: 14px;
}

.logistics-detail {
  color: #555;
  font-size: 14px;
  margin-left: 2px;
}
</style>
